module.exports = "/_next/static/images/features-creator-experience-222a78ab2b5744634e370b1df6ed24cf.png";